import { Check, X } from "lucide-react";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";

interface DeleteCarCardProps {
  onClose: () => void;
  onConfirm: (carNumber: string) => void;
  carNumberMatch: string;
}

export const DeleteCarCard = ({
  onClose,
  onConfirm,
  carNumberMatch,
}: DeleteCarCardProps) => {
  const { t } = useTranslation();
  const [carNumber, setCarNumber] = useState("");
  const [buttonDisabled, setButtonDisabled] = useState(true);

  useEffect(() => {
    if (carNumber && carNumber === carNumberMatch) {
      setButtonDisabled(false);
    }
  }, [carNumber]);

  return (
    <div className="fixed animate-none inset-0 z-50 flex items-center justify-center bg-black/50 backdrop-blur-sm">
      <div
        className="relative bg-popupLight dark:bg-popupDark text-primaryText dark:text-primaryTextDark shadow-lg rounded-2xl p-8 w-full max-w-lg mx-4 animate-fade-in-up"
        onClick={(e) => e.stopPropagation()}
      >
        <button
          onClick={onClose}
          className="absolute top-3 right-3 text-gray-500 hover:text-gray-700 dark:hover:text-gray-300 transition"
        >
          <X className="w-5 h-5" />
        </button>

        <h2 className="text-2xl font-bold text-center text-primaryText dark:text-primaryTextDark mb-4">
          {t("Remove this Car?")}
        </h2>

        <div className="space-y-4">
          <input
            type="text"
            value={carNumber}
            onChange={(e) => setCarNumber(e.target.value)}
            className="mt-1 w-full px-4 py-2 rounded-md shadow-sm dark:bg-gray-700 text-primaryText dark:text-primaryTextDark"
            placeholder={t("Enter Car Number")}
          />

          <button
            disabled={buttonDisabled}
            onClick={() => onConfirm(carNumber)}
            className="flex items-center gap-2 px-4 py-2 bg-secondaryText dark:bg-secondaryTextDark text-primaryText rounded-md disabled:cursor-not-allowed disabled:opacity-60"
          >
            <Check size={18} />
            {t("Delete")}
          </button>
        </div>
      </div>
    </div>
  );
};
